import { Button, Col, List, Row } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './GridList.module.less';

interface Props<ListItemType> {
  title?: string;
  data: Array<ListItemType>;
  loading?: boolean;
  loadMore?: boolean;
  renderItem?: (item: ListItemType, index: number) => React.ReactNode;
  onLoadMore?: () => Promise<void>;
}

export const GridList = <ListItemType extends object | null>({
  data,
  title,
  loading = false,
  loadMore = false,
  onLoadMore,
  renderItem,
}: Props<ListItemType>) => {
  const { t } = useTranslation();

  const handleLoadMore = async () => {
    onLoadMore && onLoadMore();
  };

  return (
    <List
      className={styles.gridList}
      dataSource={data}
      loading={loading}
      loadMore={
        loadMore && (
          <Row justify="center" style={{ marginTop: '25px' }}>
            <Col>
              <Button type="primary" onClick={handleLoadMore}>
                {t('LOAD_MORE_BUTTON')}
              </Button>
            </Col>
          </Row>
        )
      }
      grid={{ gutter: 24, md: 3, lg: 4, xs: 1, sm: 2, xl: 4, xxl: 6 }}
      header={title}
      renderItem={renderItem}
      rowKey={(item) => (item && (item as { id: string }).id ? (item as { id: string }).id : 'key')}
    />
  );
};
